"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { MarketCard } from "@/features/odds/components/MarketCard";
import { translateOddsSelections } from "@/features/odds/translateOddsLabels";
import { useMatchPageData } from "@/views/match/context/MatchPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
export function EmbeddedOdds() {
  const $ = _c(53);
  const labels = useLabels();
  const oddsLabels = labels.matchPage.odds;
  const {
    match,
    homeTeam,
    awayTeam,
    oddsMap,
    oddsLoading
  } = useMatchPageData();
  const kickoffAtRaw = match.timing?.kickoffTime;
  let t0;
  if ($[0] !== kickoffAtRaw) {
    t0 = kickoffAtRaw instanceof Date ? kickoffAtRaw.toISOString() : typeof kickoffAtRaw === "string" ? kickoffAtRaw : undefined;
    $[0] = kickoffAtRaw;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const kickoffAt = t0;
  let t1;
  if ($[2] !== oddsMap) {
    t1 = oddsMap.get("FT_1X2") || [];
    $[2] = oddsMap;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const matchResultOdds = t1;
  let t2;
  if ($[4] !== oddsMap) {
    t2 = oddsMap.get("DOUBLE_CHANCE") || [];
    $[4] = oddsMap;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const doubleChanceOdds = t2;
  let t3;
  if ($[6] !== oddsMap) {
    t3 = oddsMap.get("HT_FT") || [];
    $[6] = oddsMap;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const htftOdds = t3;
  let t4;
  if ($[8] !== oddsMap) {
    t4 = oddsMap.get("BOTH_TEAMS_SCORE") || [];
    $[8] = oddsMap;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const bttsOdds = t4;
  let t5;
  if ($[10] !== doubleChanceOdds || $[11] !== oddsLabels) {
    t5 = translateOddsSelections(doubleChanceOdds, "DOUBLE_CHANCE", oddsLabels);
    $[10] = doubleChanceOdds;
    $[11] = oddsLabels;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const translatedDoubleChanceOdds = t5;
  let t6;
  if ($[13] !== awayTeam.name || $[14] !== homeTeam.name || $[15] !== htftOdds || $[16] !== labels.predictorPage.odds.draw || $[17] !== oddsLabels) {
    t6 = translateOddsSelections(htftOdds, "FIRST_HALF_AND_FINAL_RESULT", oddsLabels, {
      homeTeamName: homeTeam.name,
      awayTeamName: awayTeam.name,
      drawLabel: labels.predictorPage.odds.draw
    });
    $[13] = awayTeam.name;
    $[14] = homeTeam.name;
    $[15] = htftOdds;
    $[16] = labels.predictorPage.odds.draw;
    $[17] = oddsLabels;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const translatedHtftOdds = t6;
  let t7;
  if ($[19] !== bttsOdds || $[20] !== oddsLabels) {
    t7 = translateOddsSelections(bttsOdds, "BOTH_TO_SCORE", oddsLabels);
    $[19] = bttsOdds;
    $[20] = oddsLabels;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const translatedBttsOdds = t7;
  if (oddsLoading) {
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="animate-pulse space-y-3"><div className="h-20 bg-muted/30 rounded-lg" /><div className="h-20 bg-muted/30 rounded-lg" /></div>;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    return t8;
  }
  if (oddsMap.size === 0) {
    let t8;
    if ($[23] !== oddsLabels.noOddsAvailable) {
      t8 = <p className="text-center py-6 text-muted-foreground text-sm">{oddsLabels.noOddsAvailable}</p>;
      $[23] = oddsLabels.noOddsAvailable;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    return t8;
  }
  let t8;
  if ($[25] !== kickoffAt || $[26] !== match.id || $[27] !== matchResultOdds || $[28] !== oddsLabels) {
    t8 = matchResultOdds.length > 0 && <MarketCard title={oddsLabels.markets.whoWillWin} bookmakerOdds={matchResultOdds} matchId={match.id} market="FT_1X2" kickoffAt={kickoffAt} />;
    $[25] = kickoffAt;
    $[26] = match.id;
    $[27] = matchResultOdds;
    $[28] = oddsLabels;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== doubleChanceOdds.length || $[31] !== kickoffAt || $[32] !== match.id || $[33] !== oddsLabels || $[34] !== translatedDoubleChanceOdds) {
    t9 = doubleChanceOdds.length > 0 && <MarketCard title={oddsLabels.markets.doubleChance} bookmakerOdds={translatedDoubleChanceOdds} matchId={match.id} market="DOUBLE_CHANCE" kickoffAt={kickoffAt} />;
    $[30] = doubleChanceOdds.length;
    $[31] = kickoffAt;
    $[32] = match.id;
    $[33] = oddsLabels;
    $[34] = translatedDoubleChanceOdds;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== htftOdds.length || $[37] !== kickoffAt || $[38] !== match.id || $[39] !== oddsLabels || $[40] !== translatedHtftOdds) {
    t10 = htftOdds.length > 0 && <MarketCard title={oddsLabels.markets.halfTimeFullTime} bookmakerOdds={translatedHtftOdds} matchId={match.id} market="HT_FT" kickoffAt={kickoffAt} />;
    $[36] = htftOdds.length;
    $[37] = kickoffAt;
    $[38] = match.id;
    $[39] = oddsLabels;
    $[40] = translatedHtftOdds;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== bttsOdds.length || $[43] !== kickoffAt || $[44] !== match.id || $[45] !== oddsLabels || $[46] !== translatedBttsOdds) {
    t11 = bttsOdds.length > 0 && <MarketCard title={oddsLabels.markets.bothTeamsToScore} bookmakerOdds={translatedBttsOdds} matchId={match.id} market="BOTH_TEAMS_SCORE" kickoffAt={kickoffAt} />;
    $[42] = bttsOdds.length;
    $[43] = kickoffAt;
    $[44] = match.id;
    $[45] = oddsLabels;
    $[46] = translatedBttsOdds;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  let t12;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t8 || $[51] !== t9) {
    t12 = <div className="space-y-3">{t8}{t9}{t10}{t11}</div>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t8;
    $[51] = t9;
    $[52] = t12;
  } else {
    t12 = $[52];
  }
  return t12;
}